import { Box, InputAdornment, List, TextField } from '@mui/material';
import React, { useRef } from 'react';
import { ChatCardOverlay } from './ChatCardOverlay';
import SearchIcon from '@mui/icons-material/Search';
import { useGetOrSearchChatGroupsQuery } from '@store/feature/chat/chatApi';

const GroupList = ({ handleGoToSingleChat }) => {
    const searchTimeout = 500;
    const searchRef = useRef(null);

    const [searchText, setSearchText] = React.useState('');
    const { data: groups, isLoading: isGroupsLoading } =
        useGetOrSearchChatGroupsQuery(searchText);

    const handleChange = (e) => {
        e.preventDefault();

        const text = e.target.value;

        // If search is already set, clear it
        if (searchRef.current) {
            clearTimeout(searchRef.current);
        }

        // Set a new search timeout
        searchRef.current = setTimeout(() => {
            setSearchText(text);
        }, searchTimeout);
    };

    return (
        <>
            <Box
                sx={{
                    mt: '10px',
                    px: '16px',
                    position: 'sticky',
                    top: '0',
                    pb: '4px'
                }}
            >
                <TextField
                    label="Search by name"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        )
                    }}
                    onChange={handleChange}
                />
            </Box>
            <List
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - (165px))',
                    overflowY: 'scroll'
                }}
            >
                {groups?.map((group, index) => (
                    <>
                        <ChatCardOverlay
                            imageURL={group?.image_url}
                            name={group?.name}
                            key={index}
                            userId={group?.uuid}
                            messageCount={group?.unread_messages}
                            message={group?.latest_message?.body}
                            time={group?.latest_message?.created_at}
                            isActive={group?.status === 'active'}
                            isGroup={true}
                            handleGoToSingleChat={handleGoToSingleChat}
                        />
                    </>
                ))}
            </List>
        </>
    );
};

export default GroupList;
